goog.provide('el8.appchart.refpanel.intols');

goog.require('el8.appchart.actions.intols');
goog.require('el8.appchart.dialog.addEditIntolerance');
goog.require('el8.appchart.dialog.allergyHx');
goog.require('el8.appchart.metrics');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.model.base');
goog.require('el8.ptdata.ptIntolerances');
goog.require('el8.template.appchart.refpanel.intols');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.appchart.refpanel.RefPanelSection');

el8.appchart.refpanel.intols = (function() {

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('intols');

    var renderFn = function() {
        $('#intol-section').removeClass('el8Loading');
        $('.intol-buttons', $('#intol-section')).html(
            el8.template.appchart.refpanel.intols.addNewTrigger({
                isNotDocumented: el8.ptdata.ptIntolerances.isNotDocumented()
            })
        );

        $('#intol-summary').html(
            el8.template.appchart.refpanel.intols.intoleranceList({
                actives: el8.ptdata.ptIntolerances.getAllActive().map(el8.model.toSoyMapFn),
                inactives: el8.ptdata.ptIntolerances.getAllInactive().map(el8.model.toSoyMapFn),
                isDocumentedAsNone: el8.ptdata.ptIntolerances.isDocumentedAsNone()
            })
        );
        $('.intolerance-values').html(el8.ptdata.ptIntolerances.getSummary());

        // Show all intols when list re-renders. This prevents re-delegating triggers.
        if (el8.ptdata.ptIntolerances.all().length > 5) {
            var moreIntolsTrigger = $('.more-intols-trigger');
            var lessIntolsTrigger = $('.less-intols-trigger');
            // hide toggle triggers
            moreIntolsTrigger.hide();
            lessIntolsTrigger.hide();
        }

        reportOnFirstLoad();
    };

    var that = new el8.appchart.refpanel.RefPanelSection({

        initFn: function() {
            var container = $('#intol-section');
            that.addContainer(container);
            el8.uiwidget.collapsible({
                container: container,
                triggerElt: $('#intol-summary-header'),
                statusElt: $('#intol-summary-status')
            });

            container.on('click', '.add-intol-trigger',  function(e) {
                el8.appchart.dialog.addEditIntolerance.show();

            }).on('click', '.document-none-trigger',  function(e) {
                el8.ptdata.ptIntolerances.saveAsDocumented();

            }).on('click', '.edit-text-trigger',  function(e) {
                var itemId = $(this).data('id');
                var ptIntol = el8.ptdata.ptIntolerances.getById(itemId);
                if (ptIntol) {
                    el8.appchart.dialog.addEditIntolerance.show({'ptIntolerance': ptIntol});
                    return false;
                }
            }).on('click', '.more-actions-trigger',  function(e) {
                var itemId = $(this).data('id');
                var ptIntol = itemId ? el8.ptdata.ptIntolerances.getById(itemId) : null;
                var menu = el8.appchart.actions.intols({ item: ptIntol });
                el8.appchart.refpanel.actionsMenu.display(
                    $(this),
                    null,
                    {top: 17, left: 5},
                    menu
                );
                return false;
            });

            $('#refBoardContainer').on('click', '.intol-list-actions-trigger',  function() {
                var menu = [
                    {
                        actionText: 'Add Drug Intolerance',
                        actionFn: function() { el8.appchart.dialog.addEditIntolerance.show(); }
                    },
                    {
                        actionText: 'Export Intols. to Note',
                        actionFn: function() { el8.appchart.mgr.notes.referenceIntols(); }
                    },
                    {
                        actionText: 'View Hx',
                        actionFn: function() { el8.appchart.dialog.allergyHx.show(); }
                    }
                ];

                el8.appchart.refpanel.actionsMenu.display(
                    $(this), null,
                    {'top': 17, 'left': 20},
                    menu
                );
                return false;
            });

        },
        dataRenderers: [
            {
                entitySet: el8.ptdata.ptIntolerances,
                events: [{
                    eventName: 'all',
                    fn: renderFn
                }],
                renderFn: renderFn
            }
        ]
    });

    return that;
})();
